import Main from "../layouts/Main/Main";

const indexRoutes = [
	{ path: "/*", component: Main },
];

export default indexRoutes;


